import { styled } from '@mui/material';

export const PageW = styled('div')`
  padding-left: 38px;
  margin-top: 64px;

  @media (max-width: 1023px) {
    margin-top: 0px;
    padding: 88px 16px 96px 16px;
  }
`;
